import { Grid } from "@mui/material";
import useStyles from "../styles";
import Button from "../../../components/Button/Button";

const Resume = () => {
  const classes = useStyles();

  return (
    <div>
      <Grid container spacing={4}>
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <div className="left-container">
            <h4>Resume</h4>
            <h6>See the resume of your employee, download at your convenience.</h6>
            <div className={classes.btnspace}>
              <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Download Resume" />
            </div>
          </div>
        </Grid>
        <Grid item lg={9} md={8} sm={12} xs={12}>
          <div className="right-container">

          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Resume;
